module.exports = __webpack_public_path__ + "img/liangtang-back-two@3x.d091932e.png";